"use client";
import { jsx } from "react/jsx-runtime";
import { cva } from "class-variance-authority";
import { cn } from "../utils.js";
import * as __rspack_external_react from "react";
import * as __rspack_external__radix_ui_react_progress_67feda0a from "@radix-ui/react-progress";
const progressBarVariants = cva('tw-relative tw-full tw-overflow-hidden tw-bg-neutral-light-500 dark:tw-bg-neutral-dark-400', {
    variants: {
        size: {
            sm: 'tw-h-0.4',
            md: 'tw-h-0.8'
        }
    },
    defaultVariants: {
        size: 'sm'
    }
});
const ProgressBar = /*#__PURE__*/ __rspack_external_react.forwardRef(({ className, size, value, ...props }, ref)=>/*#__PURE__*/ jsx(__rspack_external__radix_ui_react_progress_67feda0a.Root, {
        ref: ref,
        className: cn(progressBarVariants({
            size,
            className
        })),
        ...props,
        children: /*#__PURE__*/ jsx(__rspack_external__radix_ui_react_progress_67feda0a.Indicator, {
            className: "tw-h-full tw-w-full tw-flex-1 tw-bg-primary-light-500 tw-transition-all dark:tw-bg-primary-light-400 tw-rounded-r-1",
            style: {
                transform: `translateX(-${100 - (value ?? 0)}%)`
            }
        })
    }));
ProgressBar.displayName = __rspack_external__radix_ui_react_progress_67feda0a.Root.displayName;
export { ProgressBar };
